<template>
  <div class="dea-accordion-tab" :class="{ 'dea-accordion-tab--small': size === 'small' }">
    <input
      :id="id"
      type="checkbox"
      name="tabs"
      class="dea-accordion-tab__fake-input"
      :checked="showTab"
      @change="toggleAccordion"
    />
    <label v-if="showAccordionLabel" :for="id" :class="labelClass">
      <span :class="contentClass"><slot name="label"></slot></span>
      <span class="icon dea-ico-freccia-down dea-accordion__icon"></span>
    </label>
    <label v-else :class="labelClass">
      <span :class="contentClass"><slot name="label"></slot></span>
    </label>
    <div v-if="showTab && !arrowStatic" class="tab-content dea-bg-white"><slot /></div>
    <label v-if="showTab && arrowBottomOnOpen" :for="id" :class="labelClass">
      <span class="icon dea-ico-freccia-up dea-accordion__icon"></span>
    </label>
    <div v-if="showTab && arrowStatic" class="tab-content dea-bg-white"><slot /></div>
  </div>
</template>

<script>
/**
 * Single accordion tab
 */
export default {
  name: "AccordionTab",
  version: "1.5.0",
  status: "stable",
  props: {
    /**
     *
     * Class assigned to the label tag
     *
     */
    labelElementClass: {
      type: [String, Array],
      default: "",
    },
    labelContentClass: {
      type: String,
      default: "",
    },
    /**
     *
     * Tab ID
     *
     */
    id: {
      type: String,
      default: "",
      required: true,
    },
    /**
     * Tab size modifier flag.
     *
     * Currently supported values: null, "small"
     */
    size: {
      type: String,
      default: "",
    },
    open: {
      type: Boolean,
      default: false,
    },
    arrowBottomOnOpen: {
      type: Boolean,
      default: false,
    },
    arrowStatic: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showTab: this.open,
    };
  },
  computed: {
    contentClass() {
      if (this.labelContentClass) return this.labelContentClass;
      if (this.size === "small") return "dea-heading--upper__m dea-font-black";
      return "dea-heading--regular__m";
    },
    labelClass() {
      if (this.labelElementClass) return this.labelElementClass;
      if (this.size === "small") return "dea-bg-white dea-accordion-tab__label";
      return "dea-bg-grey-light dea-accordion-tab__label";
    },
    showAccordionLabel() {
      return this.arrowBottomOnOpen ? !this.showTab : true;
    },
  },
  watch: {
    open(status) {
      this.showTab = status;
    },
  },
  methods: {
    toggleAccordion() {
      this.showTab = !this.showTab;
      this.$emit("update-accordion-status", this.showTab);
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils"; //sass-lint:disable-line clean-import-paths

.dea-accordion-tab {
  .dea-ico-freccia-up {
    margin: $space-x-small 0;
  }

  & [type="checkbox"]:checked + label .dea-ico-freccia-down {
    transform: rotateX(180deg);
  }
}
</style>
